import KeyboardBindings from './KeyboardBindings';

export default {
  __init__: [
    'tokenSimulationKeyboardBindings'
  ],
  tokenSimulationKeyboardBindings: [ 'type', KeyboardBindings ]
};